import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.83908 2.88138C8.80377 1.22761 11.1933 1.22761 12.158 2.88137L18.0062 12.907C18.9784 14.5736 17.7763 16.6667 15.8468 16.6667H4.15025C2.22077 16.6667 1.01859 14.5736 1.9908 12.907L7.83908 2.88138ZM9.99935 6.66669C10.4596 6.66669 10.8327 7.03978 10.8327 7.50002V10C10.8327 10.4603 10.4596 10.8334 9.99935 10.8334C9.53911 10.8334 9.16602 10.4603 9.16602 10V7.50002C9.16602 7.03978 9.53911 6.66669 9.99935 6.66669ZM8.95768 12.5C8.95768 11.9247 9.42405 11.4584 9.99935 11.4584C10.5746 11.4584 11.041 11.9247 11.041 12.5C11.041 13.0753 10.5746 13.5417 9.99935 13.5417C9.42405 13.5417 8.95768 13.0753 8.95768 12.5Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }